exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.bucket-card .card-header, .bucket-card .card-footer {\n  padding: 0.5em 0.75em 0.5em 0.75em;\n}\n.bucket-card .card-body {\n  padding: 0.5em;\n}\n", ""]);

// exports
